

import React, { useEffect, useState } from "react";
import { useFormik, FormikProvider, Form, Field, ErrorMessage } from "formik";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import * as bie from "react-bootstrap";
import axios from "axios";
import { config } from "../CommonUtils/CommonURLS";
import { allowAlphabetAndSpacesOnly } from "../CommonUtils/CommonValidations";
// import { allowAlphabetAndSpacesOnly } from "../CommonUtils/CommonValidations";

export default function NewCollegeRegister() {

    const [univlist, setUnivlist] = useState([]);
    function GetUnivlist() {
        let url = config.url.FAC_URL + `getUniversityList`
        axios.get(url).then((res) => {
            if (res?.data?.scode === '01') {
                setUnivlist(res?.data?.data || [])
            }
            else {
                setUnivlist([])
            }
        })
    }


    useEffect(() => {
        GetUnivlist();
    }, [])

    const navigate = useNavigate();

    const [otpSent, setOtpSent] = useState(false);
    const [otpVerified, setOtpVerified] = useState(false);

    const InstitutionFormik = useFormik({
        initialValues: {
            university: "",
            collegeName: "",
            collegeType: "",
            principalName: "",
            mobile: "",
            email: "",
            otp: ""
        },

        validationSchema: Yup.object({
            university: Yup.string().required("Required"),
            collegeName: Yup.string().required("Required"),
            collegeType: Yup.string().required("Required"),
            principalName: Yup.string().required("Required"),
            mobile: Yup.string()
                .matches(/^[0-9]{10}$/, "Enter valid 10 digit mobile")
                .required("Required"),
            email: Yup.string().email("Invalid email").required("Required"),
            otp: Yup.string().when([], {
                is: () => otpSent,
                then: Yup.string().length(6, "Enter 6 digit OTP")
            })
        }),

        onSubmit: (values) => {
            if (!otpVerified) {
                alert("Please verify OTP first ❌");
                return;
            }

            alert("Successfully Registered ✅");
            navigate("/mainpage"); // change route if needed
        }
    });

    const { values, setFieldValue } = InstitutionFormik;

    // 👉 Send OTP
    const handleSendOtp = () => {
        if (values.mobile.length !== 10) {
            alert("Enter valid mobile number");
            return;
        }

        setOtpSent(true);
        alert("OTP Sent to " + values.mobile);
    };

    // 👉 Verify OTP (dummy)
    const handleVerifyOtp = () => {
        if (values.otp === "123456") {
            setOtpVerified(true);
            alert("OTP Verified ✅");
        } else {
            alert("Invalid OTP ❌");
        }
    };

    return (
        <>

            <header className="top-header top-headerfoot">
                <div className="par-logopart">
                    <img src="../images/MAINLOGO.png" alt="" className="img-fluid" />

                    <div className="paralogo-text">
                        {/* <p className="mb-0">State Project Directorate</p>
                    <p className="mb-0">Rashtriya Uchchatar Shiksha Abhiyan (RUSA)</p> */}
                        <h4 className="mb-0">
                            Higher Education Department </h4>
                        <p className="mb-0"> Government of Andhra Pradesh</p>
                    </div>
                </div>
            </header>
            <div className="faculty-form-wrapper">
                <div className="faculty-card">

                    <FormikProvider value={InstitutionFormik}>
                        <Form onSubmit={InstitutionFormik.handleSubmit}>

                            <h5 className="mb-3 innerheader-new">
                                <span>New College Registration</span>
                            </h5>

                            {/* ================= BASIC DETAILS ================= */}
                            <bie.Row>

                                <bie.Col md={3} className="mb-2">
                                    <label>University</label>

                                    <Field as="select" name="university"
                                        className="select-input"
                                    >
                                        <option value="">Select</option>
                                        {
                                            univlist.map((univ, index) => (
                                                <option key={index} value={univ.ub_code}>
                                                    {univ.ub_name}
                                                </option>
                                            ))
                                        }
                                    </Field>
                                    <ErrorMessage name="university" component="div" className="text-danger" />
                                </bie.Col>

                                <bie.Col md={3} className="mb-2">
                                    <label>College Name</label>
                                    <Field type="text" name="collegeName" className="form-control" maxLength={100} onKeyPress={allowAlphabetAndSpacesOnly} />
                                    <ErrorMessage name="collegeName" component="div" className="text-danger" />
                                </bie.Col>

                                <bie.Col md={3} className="mb-2">
                                    <label>College Type</label>
                                    <Field as="select" name="collegeType" className="select-input">
                                        <option value="">Select</option>
                                        <option value="Engineering">Engineering</option>
                                        <option value="Degree">Degree</option>
                                    </Field>
                                    <ErrorMessage name="collegeType" component="div" className="text-danger" />
                                </bie.Col>

                                <bie.Col md={3} className="mb-2">
                                    <label>Principal Name</label>
                                    <Field type="text" name="principalName" className="form-control" onKeyPress={allowAlphabetAndSpacesOnly} maxLength={60} />
                                    <ErrorMessage name="principalName" component="div" className="text-danger" />
                                </bie.Col>

                                <bie.Col md={3} className="mb-2">
                                    <label>Email</label>
                                    <Field type="email" name="email" className="form-control" maxLength={100} />
                                    <ErrorMessage name="email" component="div" className="text-danger" />
                                </bie.Col>



                                {/* ================= CONTACT ================= */}


                                <bie.Col md={3} className="mb-2">
                                    <label>Mobile Number</label>
                                    <Field
                                        type="text"
                                        name="mobile"
                                        className="form-control"
                                        maxLength={10}
                                    />
                                    <ErrorMessage name="mobile" component="div" className="text-danger" />
                                </bie.Col>

                                {/* Get OTP */}
                                <bie.Col md={2} className="mb-2 d-flex align-items-end">
                                    {!otpSent && (
                                        <button
                                            type="button"
                                            className="btn btn-warning w-100"
                                            onClick={handleSendOtp}
                                        >
                                            Get OTP
                                        </button>
                                    )}
                                </bie.Col>


                            </bie.Row>

                            {/* ================= OTP ================= */}
                            {otpSent && (
                                <bie.Row>

                                    <bie.Col md={3} className="mb-2">
                                        <label>Enter OTP</label>
                                        <Field
                                            type="text"
                                            name="otp"
                                            className="form-control"
                                            maxLength={6}
                                        />
                                        <ErrorMessage name="otp" component="div" className="text-danger" />
                                    </bie.Col>

                                    <bie.Col md={2} className="mb-2 d-flex align-items-end">
                                        {!otpVerified && (
                                            <button
                                                type="button"
                                                className="btn btn-success w-100"
                                                onClick={handleVerifyOtp}
                                            >
                                                Verify OTP
                                            </button>
                                        )}
                                    </bie.Col>

                                </bie.Row>
                            )}

                            {/* Success */}
                            {otpVerified && (
                                <div className="text-success mt-2">
                                    ✅ OTP Verified Successfully
                                </div>
                            )}

                            {/* Submit */}
                            <div className="text-end mt-3">
                                <button type="submit" className="btn btn-primary">
                                    Register
                                </button>
                            </div>

                        </Form>
                    </FormikProvider>

                </div>
            </div>

            <footer className='forgot-footer' >
                <p className='mb-0'>Designed and Developed by <a href='https://apcfss.in/' target='_blank'>
                    <img src='../images/footer-logo.svg' alt='' className='img-fluid' />
                </a>
                </p>
            </footer>
        </>
    );
}